/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export function sanitizeSegment(value: string): string {
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) {
    return "filters";
  }
  return (
    trimmed
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "") || "filters"
  );
}
